import { render, staticRenderFns } from "./DialogEventYearSpecific.vue?vue&type=template&id=935ffec8&scoped=true"
import script from "./DialogEventYearSpecific.vue?vue&type=script&lang=js"
export * from "./DialogEventYearSpecific.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935ffec8",
  null
  
)

export default component.exports